import Vue from 'vue'
import '../assets/css/element-theme/index.css'
import '../assets/css/element-theme/element-overrides.scss'
import Element from 'element-ui'
//import '../element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(Element, { locale })
